import { render } from "./PrincipalDetailInsightComponent.vue?vue&type=template&id=4122d6a9&scoped=true"
import script from "./PrincipalDetailInsightComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalDetailInsightComponent.vue?vue&type=script&lang=js"

import "./PrincipalDetailInsightComponent.vue?vue&type=style&index=0&id=4122d6a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4122d6a9"]])

export default __exports__